export const MEMBER_HOME_TRANSLATIONS = {
  "fr": {
    "memberHome.loadingAria": "Chargement de ton accueil",
    "memberHome.loading": "Chargement de ton accueil personnalisé…",
    "memberHome.retry": "Réessayer",
    "memberHome.priorities": "Tes priorités",
    "memberHome.todo": "À faire maintenant",
    "memberHome.attention": "Uniquement ce qui demande vraiment ton attention.",
    "memberHome.updated": "Tout est à jour",
    "memberHome.updatedLead": "Aucun message, rendez-vous ou suivi ne demande ton attention pour l'instant.",
    "memberHome.shortcuts": "Accès rapides",
    "memberHome.next": "Choisis ton prochain pas",
    "memberHome.shortcutsAria": "Raccourcis personnalisés",
    "memberHome.view": "Voir",
    "memberHome.hide": "Masquer",
    "memberHome.less": "Voir moins de contenus similaires",
    "memberHome.why": "Pourquoi ?",
    "memberHome.selection": "Sélection explicable",
    "memberHome.chosen": "Choisi pour toi",
    "memberHome.interests": "Modifier mes centres d'intérêt",
    "memberHome.preparing": "Ta sélection se prépare",
    "memberHome.personal": "Ton espace personnel",
    "memberHome.myEternua": "Mes Eternua",
    "memberHome.central": "Progression, missions et portefeuille centralisés.",
    "memberHome.open": "Ouvrir mon espace",
    "memberHome.level": "Niveau actuel",
    "memberHome.wallet": "Portefeuille central",
    "memberHome.synced": "Vue synchronisée",
    "memberHome.openWallet": "Ouvrir mon portefeuille",
    "memberHome.balance": "Solde en euros",
    "memberHome.points": "Points Eternua",
    "memberHome.credits": "Crédits promotionnels",
    "memberHome.pending": "Montant en attente",
    "memberHome.walletPartial": "Certaines données du portefeuille ne sont pas disponibles.",
    "memberHome.pointsNote": "Les points ne sont ni des euros ni un solde retirable.",
    "memberHome.missions": "Missions prioritaires",
    "memberHome.all": "Tout voir",
    "memberHome.noMissions": "Aucune mission prioritaire pour le moment.",
    "memberHome.recent": "Badges récents",
    "memberHome.noBadges": "Aucun badge récent",
    "memberHome.validations": "Validations en attente",
    "memberHome.pace": "Sans te presser",
    "memberHome.explore": "Explore Eternua à ton rythme",
    "memberHome.exploreLead": "Quelques univers encore peu visités, jamais toute la plateforme d'un seul coup.",
    "memberHome.universes": "Voir tous les univers",
    "memberHome.discover": "Découvrir",
    "memberHome.later": "Plus tard",
    "memberHome.close": "Fermer",
    "memberHome.settings": "Personnaliser mon accueil",
    "memberHome.personalized": "Recommandations personnalisées",
    "memberHome.personalizedLead": "Utilise uniquement tes choix autorisés et tes favoris.",
    "memberHome.history": "Historique de navigation autorisé",
    "memberHome.historyLead": "Mémorise seulement les univers visités pour mieux doser la découverte.",
    "memberHome.myInterests": "Mes centres d'intérêt",
    "memberHome.myInterestsLead": "Choisis les univers que tu souhaites voir davantage. Aucun sujet sensible n'est proposé.",
    "memberHome.myShortcuts": "Mes raccourcis",
    "memberHome.reset": "Réinitialiser la personnalisation",
    "memberHome.cancel": "Annuler",
    "memberHome.allUniverses": "Tous les univers Eternua",
    "memberHome.allUniversesLead": "Ouvre uniquement l'espace qui t'est utile aujourd'hui.",
    "memberHome.private": "Eternua · Espace privé",
    "memberHome.hello": "Bonjour",
    "memberHome.headlineStart": "Que veux-tu faire",
    "memberHome.headlineEnd": "aujourd’hui ?",
    "memberHome.sensitive": "· aucune donnée sensible exposée",
    "memberHome.privateAria": "Repères de ton espace privé",
    "memberHome.manage": "Gérer mon accueil",
    "memberHome.activeMissions": "Missions actives",
    "memberHome.appointment": "Prochain rendez-vous",
    "memberHome.journey": "Parcours",
    "memberHome.security": "Sécurité",
    "memberHome.stale": "Les dernières données chargées restent affichées.",
    "memberHome.partial": "Certaines parties de l'accueil sont temporairement indisponibles. Les informations accessibles restent affichées.",
    "memberHome.offline": "Hors connexion",
    "memberHome.unavailable": "Accueil indisponible",
    "memberHome.network": "Reviens quand le réseau sera disponible",
    "memberHome.pause": "Ton espace fait une pause",
    "memberHome.saved": "Enregistré",
    "memberHome.save": "Enregistrer",
    "memberHome.whyTitle": "Pourquoi cette proposition ?",
    "memberHome.whyDetail": "Cette proposition utilise seulement les signaux de personnalisation que tu as autorisés.",
    "memberHome.inspired": "Inspiré de tes choix, sans donnée sensible ni score caché.",
    "memberHome.disabledLead": "La personnalisation est désactivée : voici uniquement des contenus récents ou populaires.",
    "memberHome.loadingMore": "Chargement…",
    "memberHome.more": "Afficher d'autres propositions",
    "memberHome.noSelection": "Aucun contenu disponible ne correspond encore à tes choix.",
    "memberHome.unavailableValue": "Indisponible",
    "memberHome.complete": "Niveau actuel complété",
    "memberHome.saving": "Enregistrement…",
    "memberHome.personalizationOff": "Personnalisation désactivée",
    "memberHome.personalizationOn": "Personnalisation maîtrisée",
    "memberHome.protected": "Compte protégé",
    "memberHome.strengthen": "À renforcer",
    "memberHome.retryLater": "Réessaie dans un instant.",
    "memberHome.pageTitle": "Mon accueil — Eternua",
    "memberHome.pageDescription": "Ton espace privé : priorités, recommandations et activité Eternua.",
    "memberHome.levelPrefix": "Niveau",
    "memberHome.progressAria": "{percent} % vers le niveau suivant",
    "memberHome.pointsToNext": "{points} points avant le prochain niveau",
    "memberHome.noDate": "Date non renseignée",
    "memberHome.toCheck": "À consulter",
    "memberHome.today": "aujourd’hui",
    "memberHome.tomorrow": "demain",
    "memberHome.shortcut.find_job": "Trouver un emploi",
    "memberHome.shortcut.buy_sell": "Acheter ou vendre",
    "memberHome.shortcut.offer_service": "Proposer un service",
    "memberHome.shortcut.plan_outing": "Organiser une sortie",
    "memberHome.shortcut.resume_journey": "Reprendre une démarche",
    "memberHome.shortcut.messages": "Consulter mes messages",
    "memberHome.shortcut.discover": "Découvrir Eternua",
    "memberHome.universe.emploi.label": "Emploi",
    "memberHome.universe.emploi.description": "Trouve une opportunité et suis tes candidatures au même endroit.",
    "memberHome.universe.acheter.label": "Acheter",
    "memberHome.universe.acheter.description": "Parcours les annonces disponibles dans un espace sécurisé.",
    "memberHome.universe.vendre.label": "Vendre",
    "memberHome.universe.vendre.description": "Publie une annonce et garde le fil de chaque transaction.",
    "memberHome.universe.services.label": "Services",
    "memberHome.universe.services.description": "Propose ton savoir-faire ou trouve la bonne personne pour t'aider.",
    "memberHome.universe.sorties.label": "Sorties",
    "memberHome.universe.sorties.description": "Organise un moment ensemble ou rejoins un événement proche.",
    "memberHome.universe.voyages.label": "Voyages",
    "memberHome.universe.voyages.description": "Prépare une escapade et rencontre des compagnons de route.",
    "memberHome.universe.sport.label": "Sport et loisirs",
    "memberHome.universe.sport.description": "Partage une activité, du running à la photographie de nuit.",
    "memberHome.universe.animaux.label": "Animaux",
    "memberHome.universe.animaux.description": "Adopte, entraide et partage autour du bien-être animal.",
    "memberHome.universe.babysitting.label": "Babysitting",
    "memberHome.universe.babysitting.description": "Trouve une aide de confiance ou propose tes disponibilités.",
    "memberHome.universe.encheres.label": "Enchères",
    "memberHome.universe.encheres.description": "Suis les offres actives et participe en toute clarté.",
    "memberHome.universe.flash.label": "Ventes Flash",
    "memberHome.universe.flash.description": "Découvre les offres limitées encore réellement disponibles.",
    "memberHome.universe.crowdfunding.label": "Crowdfunding",
    "memberHome.universe.crowdfunding.description": "Soutiens des projets participatifs et suis leur progression.",
    "memberHome.universe.forum.label": "Forum",
    "memberHome.universe.forum.description": "Pose une question, partage une idée et échange avec la communauté.",
    "memberHome.universe.amis.label": "Groupes d'amis",
    "memberHome.universe.amis.description": "Crée un cercle et garde le lien avec les personnes qui comptent.",
    "memberHome.universe.musique.label": "Musique et clips",
    "memberHome.universe.musique.description": "Explore les créations musicales publiées sur Eternua.",
    "memberHome.universe.recompenses.label": "Récompenses",
    "memberHome.universe.recompenses.description": "Suis tes missions, tes badges et tes avantages Eternua.",
    "memberHome.universe.temples.label": "Temples Eternua",
    "memberHome.universe.temples.description": "Entre dans les espaces de connaissance et de transmission.",
    "memberTrust.welcomeAria": "Bienvenue dans ton espace de confiance",
    "memberTrust.nav": "Explorer ton espace de confiance",
    "memberTrust.welcome": "Bienvenue sur ton espace de confiance. Ici, chaque geste compte. Explore tes récompenses et partage ta confiance avec les autres.",
    "memberTrust.action.trust": "Confiance",
    "memberTrust.action.gesture": "Chaque geste compte",
    "memberTrust.action.trophy": "Récompenses",
    "memberTrust.action.share": "Partager",
    "memberFriends.title": "Premiers liens aujourd’hui",
    "memberFriends.official": "Publications officielles",
    "memberFriends.all": "Voir tout",
    "memberFriends.team": "Équipe Eternua",
    "memberFriends.view": "Voir",
    "memberFriends.empty": "Vos premiers liens apparaîtront ici",
    "memberFriends.find": "Trouver des amis",
    "memberFriends.forum": "Explorer le forum",
    "memberFriends.post.team-welcome.title": "Bienvenue sur Eternua",
    "memberFriends.post.team-trust.title": "Conseil de confiance",
    "memberFriends.post.team-mission.title": "Première mission",
    "memberFriends.post.team-forum.title": "Forum ouvert",
    "memberFriends.post.team-prelaunch.title": "Pré-lancement",
    "memberFriends.post.team-welcome.text": "Votre premier pas commence ici.",
    "memberFriends.post.team-trust.text": "Prenez le temps d’échanger avant de vous engager.",
    "memberFriends.post.team-mission.text": "Choisissez une mission à votre rythme.",
    "memberFriends.post.team-forum.text": "Lisez, échangez et partagez vos idées.",
    "memberFriends.post.team-prelaunch.text": "Découvrez le projet et ses prochaines étapes.",
    "memberMission.eyebrow": "Ce qui nous rassemble",
    "memberMission.title": "Moins d’isolement. Plus de liens humains.",
    "memberMission.lead": "Eternua rapproche les personnes autour de l’entraide, des rencontres et de projets communs, avec la confiance pour fil conducteur.",
    "memberMission.discover": "Découvrir la mission d’Eternua",
    "memberLife.aria": "Bilan personnel et idées de sorties",
    "memberLife.organise": "Organiser ensemble",
    "memberLife.organiseLead": "Dates, budget et réservations avec tes proches.",
    "memberLife.memories": "Souvenirs et transmission",
    "memberLife.memoriesLead": "Carnets familiaux et capsules temporelles.",
    "memberLife.review": "Mon bilan personnel",
    "memberLife.reviewLead": "Les échanges et les moments qui comptent.",
    "memberLife.weekend": "Que faire ce week-end ?",
    "memberLife.weekendLead": "Des sorties pour ton temps et ton budget.",
    "memberLife.premium": "Mes outils Premium",
    "memberLife.premiumLead": "Bilan détaillé, week-ends et groupes privés."
  },
  "en": {
    "memberHome.loadingAria": "Loading your home page",
    "memberHome.loading": "Loading your personalised home page…",
    "memberHome.retry": "Try again",
    "memberHome.priorities": "Your priorities",
    "memberHome.todo": "What to do now",
    "memberHome.attention": "Only what needs your attention.",
    "memberHome.updated": "Everything is up to date",
    "memberHome.updatedLead": "No message, appointment or follow-up needs your attention right now.",
    "memberHome.shortcuts": "Quick access",
    "memberHome.next": "Choose your next step",
    "memberHome.shortcutsAria": "Personalised shortcuts",
    "memberHome.view": "View",
    "memberHome.hide": "Hide",
    "memberHome.less": "See fewer similar items",
    "memberHome.why": "Why?",
    "memberHome.selection": "An explained selection",
    "memberHome.chosen": "Chosen for you",
    "memberHome.interests": "Edit my interests",
    "memberHome.preparing": "Your selection is being prepared",
    "memberHome.personal": "Your personal space",
    "memberHome.myEternua": "My Eternua",
    "memberHome.central": "Progress, missions and wallet in one place.",
    "memberHome.open": "Open my space",
    "memberHome.level": "Current level",
    "memberHome.wallet": "Central wallet",
    "memberHome.synced": "Synced view",
    "memberHome.openWallet": "Open my wallet",
    "memberHome.balance": "Balance in euros",
    "memberHome.points": "Eternua points",
    "memberHome.credits": "Promotional credits",
    "memberHome.pending": "Pending amount",
    "memberHome.walletPartial": "Some wallet information is unavailable.",
    "memberHome.pointsNote": "Points are not euros or a withdrawable balance.",
    "memberHome.missions": "Priority missions",
    "memberHome.all": "View all",
    "memberHome.noMissions": "No priority mission at the moment.",
    "memberHome.recent": "Recent badges",
    "memberHome.noBadges": "No recent badges",
    "memberHome.validations": "Pending approvals",
    "memberHome.pace": "At your own pace",
    "memberHome.explore": "Explore Eternua at your own pace",
    "memberHome.exploreLead": "A few spaces you haven’t visited much yet, at your own pace.",
    "memberHome.universes": "View all spaces",
    "memberHome.discover": "Discover",
    "memberHome.later": "Later",
    "memberHome.close": "Close",
    "memberHome.settings": "Personalise my home page",
    "memberHome.personalized": "Personalised recommendations",
    "memberHome.personalizedLead": "Uses only your permitted choices and favourites.",
    "memberHome.history": "Allow browsing history",
    "memberHome.historyLead": "Remembers only the spaces you visit to balance new discoveries.",
    "memberHome.myInterests": "My interests",
    "memberHome.myInterestsLead": "Choose the spaces you’d like to see more often. No sensitive topics are suggested.",
    "memberHome.myShortcuts": "My shortcuts",
    "memberHome.reset": "Reset personalisation",
    "memberHome.cancel": "Cancel",
    "memberHome.allUniverses": "All Eternua spaces",
    "memberHome.allUniversesLead": "Open the space you need today.",
    "memberHome.private": "Eternua · Private space",
    "memberHome.hello": "Hello",
    "memberHome.headlineStart": "What would you like to do",
    "memberHome.headlineEnd": "today?",
    "memberHome.sensitive": "· no sensitive information exposed",
    "memberHome.privateAria": "Your private space at a glance",
    "memberHome.manage": "Manage my home page",
    "memberHome.activeMissions": "Active missions",
    "memberHome.appointment": "Next appointment",
    "memberHome.journey": "Journey",
    "memberHome.security": "Security",
    "memberHome.stale": "The latest loaded information is still shown.",
    "memberHome.partial": "Some parts of your home page are temporarily unavailable. Available information is still shown.",
    "memberHome.offline": "Offline",
    "memberHome.unavailable": "Home unavailable",
    "memberHome.network": "Come back when the network is available",
    "memberHome.pause": "Your space is taking a break",
    "memberHome.saved": "Saved",
    "memberHome.save": "Save",
    "memberHome.whyTitle": "Why this suggestion?",
    "memberHome.whyDetail": "This suggestion only uses personalisation signals you have permitted.",
    "memberHome.inspired": "Inspired by your choices, with no sensitive data or hidden score.",
    "memberHome.disabledLead": "Personalisation is disabled: only recent or popular content is shown.",
    "memberHome.loadingMore": "Loading…",
    "memberHome.more": "Show more suggestions",
    "memberHome.noSelection": "No available content matches your choices yet.",
    "memberHome.unavailableValue": "Unavailable",
    "memberHome.complete": "Current level complete",
    "memberHome.saving": "Saving…",
    "memberHome.personalizationOff": "Personalisation disabled",
    "memberHome.personalizationOn": "Personalisation under your control",
    "memberHome.protected": "Protected account",
    "memberHome.strengthen": "Needs strengthening",
    "memberHome.retryLater": "Try again in a moment.",
    "memberHome.pageTitle": "My home — Eternua",
    "memberHome.pageDescription": "Your private space: priorities, recommendations and Eternua activity.",
    "memberHome.levelPrefix": "Level",
    "memberHome.progressAria": "{percent}% towards the next level",
    "memberHome.pointsToNext": "{points} points to the next level",
    "memberHome.noDate": "No date provided",
    "memberHome.toCheck": "View details",
    "memberHome.today": "today",
    "memberHome.tomorrow": "tomorrow",
    "memberHome.shortcut.find_job": "Find a job",
    "memberHome.shortcut.buy_sell": "Buy or sell",
    "memberHome.shortcut.offer_service": "Offer a service",
    "memberHome.shortcut.plan_outing": "Organise an outing",
    "memberHome.shortcut.resume_journey": "Resume an activity",
    "memberHome.shortcut.messages": "Check my messages",
    "memberHome.shortcut.discover": "Discover Eternua",
    "memberHome.universe.emploi.label": "Jobs",
    "memberHome.universe.emploi.description": "Find an opportunity and track your applications in one place.",
    "memberHome.universe.acheter.label": "Buy",
    "memberHome.universe.acheter.description": "Browse available listings in a secure space.",
    "memberHome.universe.vendre.label": "Sell",
    "memberHome.universe.vendre.description": "Publish a listing and keep track of every transaction.",
    "memberHome.universe.services.label": "Services",
    "memberHome.universe.services.description": "Offer your skills or find the right person to help you.",
    "memberHome.universe.sorties.label": "Outings",
    "memberHome.universe.sorties.description": "Organise time together or join a nearby event.",
    "memberHome.universe.voyages.label": "Travel",
    "memberHome.universe.voyages.description": "Plan a getaway and meet travel companions.",
    "memberHome.universe.sport.label": "Sport and leisure",
    "memberHome.universe.sport.description": "Share an activity, from running to night photography.",
    "memberHome.universe.animaux.label": "Animals",
    "memberHome.universe.animaux.description": "Adopt, help each other and share around animal welfare.",
    "memberHome.universe.babysitting.label": "Babysitting",
    "memberHome.universe.babysitting.description": "Find trusted help or offer your availability.",
    "memberHome.universe.encheres.label": "Auctions",
    "memberHome.universe.encheres.description": "Track active offers and participate with clarity.",
    "memberHome.universe.flash.label": "Flash sales",
    "memberHome.universe.flash.description": "Discover limited offers that are still available.",
    "memberHome.universe.crowdfunding.label": "Crowdfunding",
    "memberHome.universe.crowdfunding.description": "Support community projects and track their progress.",
    "memberHome.universe.forum.label": "Forum",
    "memberHome.universe.forum.description": "Ask a question, share an idea and talk with the community.",
    "memberHome.universe.amis.label": "Friend groups",
    "memberHome.universe.amis.description": "Create a circle and stay connected to the people who matter.",
    "memberHome.universe.musique.label": "Music and clips",
    "memberHome.universe.musique.description": "Explore musical creations published on Eternua.",
    "memberHome.universe.recompenses.label": "Rewards",
    "memberHome.universe.recompenses.description": "Track your missions, badges and Eternua benefits.",
    "memberHome.universe.temples.label": "Eternua temples",
    "memberHome.universe.temples.description": "Enter spaces of knowledge and sharing.",
    "memberTrust.welcomeAria": "Welcome to your space of trust",
    "memberTrust.nav": "Explore your space of trust",
    "memberTrust.welcome": "Welcome to your space of trust. Every gesture counts here. Explore your rewards and share your trust with others.",
    "memberTrust.action.trust": "Trust",
    "memberTrust.action.gesture": "Every gesture counts",
    "memberTrust.action.trophy": "Rewards",
    "memberTrust.action.share": "Share",
    "memberFriends.title": "First connections today",
    "memberFriends.official": "Official posts",
    "memberFriends.all": "View all",
    "memberFriends.team": "Eternua team",
    "memberFriends.view": "View",
    "memberFriends.empty": "Your first connections will appear here",
    "memberFriends.find": "Find friends",
    "memberFriends.forum": "Explore the forum",
    "memberFriends.post.team-welcome.title": "Welcome to Eternua",
    "memberFriends.post.team-trust.title": "Trust advice",
    "memberFriends.post.team-mission.title": "First mission",
    "memberFriends.post.team-forum.title": "Open forum",
    "memberFriends.post.team-prelaunch.title": "Pre-launch",
    "memberFriends.post.team-welcome.text": "Your first step begins here.",
    "memberFriends.post.team-trust.text": "Take time to talk before committing.",
    "memberFriends.post.team-mission.text": "Choose a mission at your own pace.",
    "memberFriends.post.team-forum.text": "Read, talk and share your ideas.",
    "memberFriends.post.team-prelaunch.text": "Discover the project and its next steps.",
    "memberMission.eyebrow": "What brings us together",
    "memberMission.title": "Less isolation. More human connections.",
    "memberMission.lead": "Eternua brings people together through mutual help, meetings and shared projects, with trust at the heart of it all.",
    "memberMission.discover": "Discover Eternua’s mission",
    "memberLife.aria": "Personal review and outing ideas",
    "memberLife.organise": "Organise together",
    "memberLife.organiseLead": "Dates, budget and bookings with people close to you.",
    "memberLife.memories": "Memories and legacy",
    "memberLife.memoriesLead": "Family journals and time capsules.",
    "memberLife.review": "My personal review",
    "memberLife.reviewLead": "The exchanges and moments that matter.",
    "memberLife.weekend": "What to do this weekend?",
    "memberLife.weekendLead": "Outings for your time and budget.",
    "memberLife.premium": "My Premium tools",
    "memberLife.premiumLead": "Detailed review, weekends and private groups."
  }
};
